import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';
import { useHistory, useParams, useLocation } from "react-router-dom";

import './styles.scss';

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Alert, ExpandableSection, Tiles,
    Container, Header, ColumnLayout, Spinner, Link, Tabs, Button, Table, SpaceBetween, Modal, FileUpload, Flashbar,
    RadioGroup,
    FileInput,
    Grid,
    SegmentedControl,
    Popover,
    Checkbox
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import { useAuth } from "../../context/AuthContextProvider";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import Amplify, { Storage } from 'aws-amplify';
import { getFriscoS3Config } from 'src/utilities/AWSServices';

import MJEmonitoringSampleFile from '../../images/MJEMonitoringSampleFile.png'
import { PORTAL } from "src/constants/AppConstants";
import { setCurrentAppId } from '../../store/userAuthSlice';
import { setPendingTrigger, ActionTriggerType } from '../../store/pulseSurveyTriggerSlice';
import * as XLSX from 'xlsx';
import { getMappingById, getProcessById, getFRISCOPreValidationResults, friscoSubmit, friscoResubmit, getLatestCorpReportingUploadMetadata, getFRISCOPreValidationMatchingExcelSheetResults, onMatchResults, getNotification, createAuditLog, getEmployeeDetailsByLogin } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus"
import { FRISCO_NEGATIVE_STATUS_FOR_UPLOAD, FRISCO_POSITIVE_STATUS, FRISCO_STATUS, PROCESS_KEYS, CRA_LINKS, WB_OPTIONS, withoutTancRowId } from './Constants';
import { configureFriscoS3, configureGenericAppSync, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isUploaderAllowed } from './AccessUtilities';
import { request as requestPlugin } from 'src/plugins/CorpReportingUploadAccess'
import { request as requestViewPlugin, disabled as isDisabledPlugin, getFilteredWbOptions  as getFilteredWbOptionsPlugin} from 'src/plugins/CorpReportingViewOptions'
import { getCurrentQuarter, getQuarterForUpload } from '../CorpReporting/Utility';
import { checkIfPortalAdmin, checkIfSupportAdmin } from 'src/checkPageAccess';
import { formNotificationItems } from './NotificationUtilities';
import { getAssociatedTANCSession, getAssociatedTANCSessionSync, getRowLocksForSession, tancAssociationStatusWithRowLock, tancRowLockEvent, tancSubmitRebase, updateTANCLock } from 'src/utilities/AppSyncPlusAPIs';
import TANCSession from '../TANC/TANCSession';
import RequiredDateColumns from '../TaskManager/RequiredDateColumns';
import { getRequiredDateColumnsByService, getServiceAttributesByService } from '../TaskManager/api';
import appSettings from '../CorpReporting/app_settings';
import { useBreadcrumb } from '../../generic-components/Breadcrumb/useBreadcrumb';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getDisplayName } from '../utils/displayNameUtils';
import { updateProcessComment } from 'src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus';
import ProcessCommentSection from '../Templates/components/ProcessCommentSection';
import {  uploadDocumentToVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';

export default (props) => {
    const userId = useSelector((globalState) => globalState.auth.userId)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const history = useHistory();
    const userAuthenticationDetails = useAuth();
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    let { id: paramId } = useParams();
    let { pid: paramPid } = useParams();
    
    const id = props.id || paramId;
    const pid = props.pid || paramPid;
    const [processData, setProcessData] = useState({})
    // Required "date" fields (from Task Manager dashboards this process's app is on),
    // fetched in the background when a file is selected so validation time is reused.
    const [requiredDateDashboards, setRequiredDateDashboards] = useState(null);
    const [requiredDateLoading, setRequiredDateLoading] = useState(false);
    const [requiredDateError, setRequiredDateError] = useState('');
    // Union of mandatory supporting-doc file types configured for this service in
    // any Task Manager dashboard's Row Settings; merged with the app-level attribute.
    const [dashboardMandatoryDocs, setDashboardMandatoryDocs] = useState([]);
    // True when any Task Manager dashboard's Row Settings for this service turns on
    // Show Self Certify; OR'd with the app-level requireCertificationCheck.
    const [dashboardSelfCertify, setDashboardSelfCertify] = useState(false);
    // Per-service attribute map keyed by dashboard, { "<dashboard_id>": { <attr_type>: value } },
    // from the same getServiceAttributesByService call. Used to attach each required
    // DATE column's stored datetime (service_attributes are keyed by column name).
    const [dashboardServiceAttributes, setDashboardServiceAttributes] = useState({});
    // Checked "optional inputs" selections, shaped { "<dashboard_id>": { dates:[...] } },
    // sent as task_manager_inputs on the FRISCO transaction at submit.
    const [taskManagerInputs, setTaskManagerInputs] = useState({});
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState();
    const [mappingId, setMappingId] = useState('');
    const dispatch = useDispatch()
    const [activeTabId, setActiveTabId] = useState("first");
    const [isFileSelected, setIsFileSelected] = useState(false);
    const [showFileNotSeleted, setShowFileNotSeleted] = useState(false);
    const currentAppId = useSelector((globalState) => globalState.auth.currentAppId)
    const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const corpReportingQuarter = useSelector((globalState) => globalState.auth.corpReportingQuarter)
    const [showLoadingIcon, setShowLoadingIcon] = useState(false);
    const [columnsList, setColumnsList] = useState({})
    const [items, setItems] = useState([])
    const [previewItems, setPreviewItems] = useState([])
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [warningMessage, setWarningMessage] = useState('');
    const [mainErrorMessage, setMainErrorMessage] = useState('');
    const [missingFields, setMissingFields] = useState(new Set());
    const [colsNotInRequiredOrder, setColsNotInRequiredOrder] = useState(false);
    const [colCountMoreThanExpected, setColCountMoreThanExpected] = useState(false);
    const [comparisonValidationErrors, setComparisonValidationErrors] = useState({});
    const [nonEmptyColumnErrors, setNonEmptyColumnErrors] = useState({});
    const [emptyRowsValidationResult, setEmptyRowsValidationResult] = useState({});
    const [emptyColumnIndices, setEmptyColumnIndices] = useState([]);
    const [inputFiles, setInputFiles] = useState([]);
    const [supportedFormats, setSupportedFormats] = useState('.csv');
    const [loadingMessage, setLoadingMessage] = useState('loading, please wait..');
    const [showUploadBtn, setShowUploadBtn] = useState(false)
    const [fileReference, setFileReference] = useState('');
    const [inputSheets, setInputSheets] = useState([]);
    const [selectedSheet, setSelectedSheet] = useState('');
    const [disableProceedButton, setDisableProceedButton] = useState(true)
    const [backUrl, setBackUrl] = useState(null)
    const [taskId, setTaskId] = useState(null)
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [uploadAccessForTheQuarter, setUploadAccessForTheQuarter] = useState(false);
    const [rawFile, setRawFile] = useState(null)
    const [rawFileData, setRawFileData] = useState(null)
    const stageSessionId = useRef()
    const stageSessionFileExt = useRef()
    // Row-lock submit info captured at Step 1 (delta key + rows/deletions to submit),
    // committed to TANCRowLock only at Step 3 (onSubmitClick) so nothing is written
    // until the user confirms. Survives the grid unmount when the wizard advances.
    const rowLockSubmitRef = useRef(null)
    // Set true once a Step-3 submit is confirmed (rows flipped SUBMITTED + rebase fired).
    // Guards releaseTancRowLocksOnCancel from freeing those in-flight SUBMITTED rows.
    const submitConfirmedRef = useRef(false)
    // sometimes updating setSelectedSheet is not reflecting when making a validation request since that is async function also. hence using this copy variable
    const stageSessionSelectedSheet = useRef()
    const [providedCoulumns, setProvidedCoulumns] = useState([])
    const [comments, setComments] = useState(null)
    const [notificationBarItems, setNotificationBarItems] = useState([])
    const [soxAuditFailed, setSoxAuditFailed] = useState(false)
    const [wbType, setWbType] = useState(false)
    const [preWbFileId, setPreWbFileId] = useState(null)
    const [preWbMetadata, setPreWbMetadata] = useState(null)
    const [isPreWbLoading, setIsPreWbLoading] = useState(false)
    const [supportingDocs, setSupportingDocs] = useState([])
    const [shouldShowWbSelection, setShouldShowWbSelection] = useState(false)
    const [shouldShowPdfUpload, setShouldShowPdfUpload] = useState(false)
    const [allowNoPostWBResubmit, setAllowNoPostWBResubmit] = useState(false)
    const [tancInfo, setTancInfo] = useState(null)
    const [sessionDetails, setSessionDetails] = useState(null)
    // Initialize uploadSegment based on URL parameter to avoid flash when loading inline edit
    const [uploadSegment, setUploadSegment] = useState(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const modeParam = urlParams.get('mode');
        
        if (props.disableAppLayout && modeParam === 'inline_edit') {
            return 'tanc';
        }
        return 'upload';
    })
    const [approverNames, setApproverNames] = useState([]);
    const [missingMandatoryDocs, setMissingMandatoryDocs] = useState([])
    const [isFriscoDisabled, setIsFriscoDisabled] = useState(false)
    const [disabledMessages, setDisabledMessages] = useState([])
    const [hasUploaderAccess, setHasUploaderAccess] = useState(true)
    const [isCommentSubmitting, setIsCommentSubmitting] = useState(false)
    const [requireCertificationCheck, setRequireCertificationCheck] = useState(false)
    const [hideLoadTable, setHideLoadTable] = useState(false)
    const [certificationChecked, setCertificationChecked] = useState(false)
    const [shouldShowErrorDisclaimer, setShouldShowErrorDisclaimer] = useState(false)
    const { breadcrumbItems, generateBreadcrumbs } = useBreadcrumb();
    
    // Helper function to sanitize file names by removing forbidden characters
    const sanitizeFileName = (fileName) => {
        return fileName.replace(/["*\\/:<?|]/g, '');
    };
    
    // Helper function to create a new File object with a sanitized name
    const createSanitizedFile = (file) => {
        const sanitizedName = sanitizeFileName(file.name);
        if (sanitizedName !== file.name) {
            return new File([file], sanitizedName, { type: file.type, lastModified: file.lastModified });
        }
        return file;
    };
    
    // Helper function to sanitize an array of files
    const sanitizeFiles = (files) => {
        return files.map(file => createSanitizedFile(file));
    };
    const ln = useLocation()
    useVisibleTimeTracker([{
        metricName : 'actionPerformedBy',
        metricValue : userId,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    },
    {
        metricName : 'pagePath',
        metricValue : `${ln.pathname}`,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
    }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FRISCO);
    // Comment functionality - using Redux selector
    const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
    const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)

    useEffect(() => {
        configureFriscoS3()
        if (pid) {
            loadData();
            // Fetch required date fields on entry so the checkbox section by the
            // Submit button shows for every FRISCO variant (standard + workdocs),
            // not just when the standard file-select changeHandler runs.
            fetchRequiredDateColumns();
            fetchServiceAttributes();
        }
        if (id) {
            dispatch(setCurrentAppId(id))
        }
        setBackUrl(getParam('back'))
        setTaskId(getParam('taskId'))
        return () => {
            // this now gets called when the component unmounts
            configureGenericS3()
        };
    }, []);



    useEffect(() => {
        configureFriscoS3()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [isCurrentAppAuthorised]);

    useEffect(() => {
        stageSessionSelectedSheet.current = selectedSheet
        if (selectedSheet) {
            setDisableProceedButton(false)
        } else {
            setDisableProceedButton(true)
        }
        return () => {
            // this now gets called when the component unmounts
        };
    }, [selectedSheet]);

    useEffect(() => {
        if (isAuthorized === true || isAuthorized === false) {
            setIsCheckingAccess(!isCheckingAccess);
        }
    }, [isAuthorized]);


    const getParam = (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
    }

    const getProcessDisplayName = () => {
        const aliasParam = getParam('alias');
        return getDisplayName(aliasParam, processData[PROCESS_KEYS.process_name], processData[PROCESS_KEYS.label]);
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        setLoadingMessage("loading, please wait...")
        setShowLoadingIcon(true);
        setShowUploadBtn(false)
        // setProcessData()
        await Promise.all([
        new Promise((resolve, reject) => {
            getNotification(pid, 'FRISCO_PROCESS', function onSuccess(response) {
            formNotificationItems(response, setNotificationBarItems)
            JSON.parse(response.data.getNotification).forEach((notification, index) => {
                if (notification.notification_type == 'FRISCO_2PR_ALIAS_VALIDATION_ERROR') {
                    setSoxAuditFailed(true)
                    setErrorMessage("Minimum of 2 approvers required.")
                } else if (notification.info?.includes("APPROVER")) {
                    setSoxAuditFailed(true)
                    setErrorMessage(`The approver list has to be updated. Please contact process owner.`)
                } else if (notification.info?.includes(userId) &&
                    (notification.notification_type == 'ALIAS_PATROL_COST_CENTER_MISMATCH'
                        || notification.notification_type == 'ALIAS_PATROL_MANAGER_LOGIN_MISMATCH'
                        || notification.notification_type == 'ALIAS_PATROL_JOB_STATUS_MISMATCH')) {
                    setSoxAuditFailed(true)
                    setErrorMessage(`${notification.notification_message} Please contact process owner.`)
                }
            })

            resolve();

        }, function onFailure(response) {
            reject();
        })
        }),
        new Promise((resolve, reject) => {
            tancAssociationStatusWithRowLock(pid, 'FRISCO', function onSuccess(response) {
            setTancInfo(response?.data?.tancAssociationStatus)
            if (response?.data?.tancAssociationStatus?.status) {
                // Active status - get association id
                getAssociatedTANCSession(pid, 'FRISCO', function onSuccess(response) {
                    // Check URL parameters to determine the mode when in iframe
                    const modeParam = getParam('mode');
                    if (props.disableAppLayout && modeParam === 'inline_edit') {
                        setUploadSegment('tanc')
                    } else if (props.disableAppLayout) {
                        // Default to upload mode when in iframe without specific mode parameter
                        setUploadSegment('upload')
                    } else {
                        // Original behavior for non-iframe context
                        setUploadSegment('tanc')
                    }
                    setSessionDetails(response?.data?.getAssociatedTANCSession?.items?.[0])
                    resolve();
                }, function onFailure(response) {
                    reject();
                })
            } else {
                resolve();
            }
            
        }, function onFailure(response) {
            reject();
        })
            }),
        new Promise((resolve, reject) => {
                getProcessById(pid, async function onSuccess(response) {
            const r = response.data.getProcessByIDV2RDS
            if(r[PROCESS_KEYS.schema] && r[PROCESS_KEYS.schema].length > 0){
                // Hide the TANC row-lock id; the backend appends it to every upload.
                r[PROCESS_KEYS.schema] = withoutTancRowId(r[PROCESS_KEYS.schema])
                r[PROCESS_KEYS.schema].sort((a, b) => a.column_index - b.column_index)
            }
            setProcessData(r)
            // Move hide load table function to just after getting process id data, 
            // This is now not dependant on permissions etc
            requestViewPlugin({ appId: id, stage: currentStage }, function onResponse(response) {
                setHideLoadTable(response?.hideLoadTable)
            })
            
            // Update breadcrumbs based on where user came from
            const backUrl = getParam('back');
            const deliverableRef = r[PROCESS_KEYS.process_name] || `Process ${pid}`;
            await generateBreadcrumbs(backUrl, deliverableRef, id, pid);
            setSupportedFormats(getSupportedFormats(r))
            if (r[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift' && FRISCO_NEGATIVE_STATUS_FOR_UPLOAD.includes(r[PROCESS_KEYS.status])) {
                setShowLoadingIcon(false);
                setShowUploadBtn(false)
                setErrorMessage(`Cannot upload input file. The table creation status is : ${r[PROCESS_KEYS.status]}`)
                resolve();
                return;
            }
            
            
            let isAllowed = isPortalAdmin || await checkIfPortalAdmin(userId, currentStage)
            if (!isAllowed) {
                isAllowed = isSupportAdmin || await checkIfSupportAdmin(userId, currentStage)
            }

            // temporary if condition for internal testing - the portal/support admin conditions are ignored for CRA app to simulate normal acc users permissions
            if (currentAppId == appSettings[currentStage].appId) {
                isAllowed = false
            }
            if (!isAllowed) {
                isAllowed = await isUploaderAllowed(r, userId, currentStage)
            }
            if (!isAllowed) {

                setShowLoadingIcon(false);
                setShowUploadBtn(false)
                if (id == appSettings[currentStage].appId) {
                    setErrorMessage("You don't have permission to perform an upload action. You are not part of the Uploader group for this deliverable  If you believe you should have access please contact the SEC team to request membership in the appropriate group")
                }else{
                    setErrorMessage("If you believe you should have access please contact the SEC team to request membership in the appropriate group")
                }
            } else {
                // Check uploader access
                setHasUploaderAccess(isAllowed);
                
                getMappingById(id, pid, function onSuccess(response) {
                    setMappingId(response.data.getMappingIDV2.mapping_id)
                    setShowLoadingIcon(false);
                    setShowUploadBtn(true)
                },
                    function onFailure(response) {
                        // setErrorMessage("Could not get app mapping information")
                        setShowLoadingIcon(false);
                        setShowUploadBtn(true)
                    })
                let quarter = getQuarterForUpload()
                requestPlugin({ appId: id, processId: pid, stage: currentStage, group: response.data.getProcessByIDV2RDS[PROCESS_KEYS.group_id], quarter: quarter }, function onResponse(response) {
                    setUploadAccessForTheQuarter(response.result)
                    if (!response.result) {
                        setErrorMessage(` A process is either in-progress or complete. Current status is '${response.message}'`)
                    }
                    if (response.comments) {
                        setComments(response.comments)
                    }
                })
                requestViewPlugin({ appId: id, stage: currentStage }, function onResponse(response) {
                    setShouldShowWbSelection(response?.allowWBSelection)
                    setShouldShowPdfUpload(response?.allowSupportingDocUpload)
                    setRequireCertificationCheck(response?.requireCertificationCheck)
                    setShouldShowErrorDisclaimer(response?.shouldShowErrorDisclaimer)
                    setAllowNoPostWBResubmit(response?.allowNoPostWBResubmit)
                })
                isDisabledPlugin({ appId: id, stage: currentStage, info: r }, function onResponse(response) {
                    let messages = []
                    if(response?.disabled){
                        setIsFriscoDisabled(true)
                        messages.push('This deliverable is disabled and not required for this quarter. If you believe this not to be correct, please contact the SEC team')
                    }
                    if(response?.annualOnly && getCurrentQuarter()!="Q1"){
                        setIsFriscoDisabled(true)
                        messages.push('This deliverable is ANNUAL ONLY and not required for this quarter. If you believe this not to be correct, please contact the SEC team')
                    }
                    if(response?.isLocked){
                        messages.push('This deliverable has been locked. If you believe this not to be correct, please contact the SEC team')
                        setIsFriscoDisabled(true)
                    }
                    setDisabledMessages(messages)
                })
                if(r[PROCESS_KEYS.environment] === "Transfer_S3_Workdocs"){
                    setShouldShowPdfUpload(true)
                }
            }
            resolve();
        }, function onFailure(response) {
            setErrorMessage("Could not load process information")
            setShowLoadingIcon(false);
            setShowUploadBtn(true)
            reject();
        }) 
            })])
        
    } finally {
        if(!pageLoadTime.isStopped) {
        stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FRISCO)
        }
    }
}

    const getAllowedFileFormats = () => {
        if (processData && processData.hasOwnProperty(PROCESS_KEYS.file_types) && processData[PROCESS_KEYS.file_types]) {
            return processData[PROCESS_KEYS.file_types]
        }
        return []
    }

    const getMandatoryColumnNames = () => {
        let mandatoryColumns = new Set()

        if (processData && processData.hasOwnProperty(PROCESS_KEYS.schema)) {
            processData[PROCESS_KEYS.schema].forEach((item) => {
                mandatoryColumns.add(item['column_name'])
            })
        }
        return mandatoryColumns
    }

    const renderDataErrorDisclaimer = () => {
        if (!shouldShowErrorDisclaimer) return null;
        return (
            <>
                <br/>  
                The errors listed below refer to the &#39;Data&#39; tab in your uploaded Excel file. Please make sure you are using the <Link external href={CRA_LINKS.LATEST_TEMPLATE}>latest template</Link>, review Data tab for required corrections, and resubmit. If issues persist, please <Link external href={CRA_LINKS.CONTACT_ATG}>contact ATG</Link> for assistance
            </>
        );
    };

    const renderFileErrorDisclaimer = () =>{
        if (!shouldShowErrorDisclaimer) return null;
        return (
            <>
                <br/>  
                Please make sure you are using the <Link external href={CRA_LINKS.LATEST_TEMPLATE}>latest template</Link>. If issues persist, please <Link external href={CRA_LINKS.CONTACT_ATG}>contact ATG</Link> for assistance
            </>
        );
    }

    useEffect(() => {
        const fetchApprovers = async () => {
            if (processData && processData.hasOwnProperty(PROCESS_KEYS.approvers) && processData[PROCESS_KEYS.approvers]?.length > 0) {
                setApproverNames(processData[PROCESS_KEYS.approvers])
            }
        };

        fetchApprovers();
    }, [processData]);


    const isAllowedFileFormat = (format, allowedFileFormats) => {
        let isAllowed = false
        // console.log(format)
        if (!format) {
            isAllowed = false
        }
        let supportedFormats = []
        for (let i = 0; i < allowedFileFormats.length; i++) {
            if (allowedFileFormats[i] == 'CSV') {
                supportedFormats.push('text/csv')
                supportedFormats.push('text/plain') 
                supportedFormats.push('text/x-csv')
                supportedFormats.push('application/vnd.ms-excel')
                supportedFormats.push('application/csv')
                supportedFormats.push('application/x-csv')
                supportedFormats.push('text/comma-separated-values')
                supportedFormats.push('text/x-comma-separated-values')
                supportedFormats.push('text/tab-separated-values')
            } else if (allowedFileFormats[i] == 'Excel') {
                supportedFormats.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                supportedFormats.push('application/vnd.ms-excel.sheet.macroenabled.12')
                supportedFormats.push('application/vnd.ms-excel.sheet.binary.macroenabled.12')
                supportedFormats.push('application/vnd.ms-excel')
                supportedFormats.push('application/msexcel')
            } else if (allowedFileFormats[i] == 'PDF') {
                supportedFormats.push('application/pdf')
                supportedFormats.push('application/x-pdf')
                supportedFormats.push('application/acrobat')
            } else if (allowedFileFormats[i] == 'Word') {
                supportedFormats.push('application/msword')
                supportedFormats.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                supportedFormats.push('application/vnd.ms-word.document.macroEnabled.12')
                supportedFormats.push('application/doc')
                supportedFormats.push('application/docx')
            }
        }
        isAllowed = supportedFormats.some(item => format === item);
        return isAllowed
    }
    const validateInputFileFormat = (file) => {
        let allowedFileFormats = getAllowedFileFormats()
        let isAllowed = isAllowedFileFormat(file?.type, allowedFileFormats)
        if (!file?.type) {
            throw new Error("Please upload an input file")
        }
        if (!isAllowed) {
            throw new Error(`File format is not allowed : ${file?.type}`);
        }
        return isAllowed
    }

    const validateEmptyContents = (rowData) => {
        if (!rowData || rowData.length == 0) {
            throw new Error("The inputs rows are empty")
        }
    }

    const resetValidationErrorLogs = () => {
        setProvidedCoulumns([])
        setMissingFields(new Set())
        setColCountMoreThanExpected(false)
        setColsNotInRequiredOrder(false)
        setEmptyRowsValidationResult({})
        setEmptyColumnIndices([])
        setComparisonValidationErrors({})
        setNonEmptyColumnErrors({})
    }

    const postDataSelection = async () => {
        if (shouldShowWbSelection && !wbType) {
            setErrorMessage('Please select a WB type before proceeding.')
            return
        }
        setLoadingMessage("validating the uploaded file, please wait...")
        setDisableProceedButton(true)
        setShowLoadingIcon(true)
        resetValidationErrorLogs()
        onMatchResults(stageSessionId.current, function onResult(result) {
            let validationResponse = JSON.parse(result.value.data.onMatchResults.payload)
            setProvidedCoulumns(validationResponse.normalised_columns)
            setMissingFields(new Set(validationResponse.missing_fields))
            setColCountMoreThanExpected(validationResponse.column_count_more_than_expected)
            setColsNotInRequiredOrder(validationResponse.columns_not_in_required_order)
            setEmptyRowsValidationResult(validationResponse.empty_rows_present || {})
            setEmptyColumnIndices(validationResponse.empty_columns_present || [])
            // Handle comparison validation errors
            if (validationResponse.comparison_validation_errors) {
                setComparisonValidationErrors(validationResponse.comparison_validation_errors)
            }

            // Handle non-empty column validation errors
            if (validationResponse.non_empty_column_errors) {
                setNonEmptyColumnErrors(validationResponse.non_empty_column_errors)
            }

            if (validationResponse.missing_fields.length >= 1 || validationResponse.columns_not_in_required_order || validationResponse.column_count_more_than_expected || validationResponse.comparison_validation_errors || validationResponse.non_empty_column_errors) {
                setShowLoadingIcon(false)
                return
            }
            const definitions = validationResponse.normalised_columns.map(colName => ({
                id: colName,
                header: colName,
                cell: item => item[colName] || '-'
            }))
            setColumnsList(definitions)
            setPreviewItems(validationResponse.top_columns)
            setShowLoadingIcon(false)
            setDisableProceedButton(false)
            setActiveTabId('second')
        }, function onFailure(error) {
            console.log(error)
        })

        await new Promise(resolve => setTimeout(resolve, 1000));
        getFRISCOPreValidationResults(stageSessionId.current, stageSessionFileExt.current, pid, stageSessionSelectedSheet.current, function onSuccess(response) {

        }, function onFailure(error) {

        })


    }

    const processExcelSheet = async () => {
        try {
            setErrorMessage('')
            const file = inputFiles[0]
            setRawFile(file)
            postDataSelection()
        } catch (error) {
            setErrorMessage(error?.message)
            setLoadingMessage("")
            setShowLoadingIcon(false)
        }
    }

    const getBlankSheetsMessage = (emptyColumnSheets, emptyColumnSheetsObject) => {
        return <>Empty columns found: {
            emptyColumnSheets.map(sheet => <div> Sheet: {sheet}, Columns: {emptyColumnSheetsObject[sheet].join(',')} </div>)
        }</>
    }

    const validateFileSize = (fileDesc) => {
        if (fileDesc.size / 1000000 >= 200) {
            throw ({ error: 'FILE MAX LIMIT', message: "Max file limit is 200MB" })
        } else {
            setErrorMessage()
        }
    }

    // Fire-and-forget fetch of the required DATE fields for this FRISCO process.
    // Kicked off when a file is selected; runs alongside the (slower) file
    // validation so the result is ready by the time the user reaches submit.
    const fetchRequiredDateColumns = () => {
        if (!pid) return;
        setRequiredDateLoading(true);
        setRequiredDateError('');
        getRequiredDateColumnsByService(pid, 'FRISCO')
            .then((result) => {
                setRequiredDateDashboards(Array.isArray(result) ? result : []);
            })
            .catch((e) => {
                setRequiredDateError(e?.message || 'Failed to load required date fields');
                setRequiredDateDashboards([]);
            })
            .finally(() => setRequiredDateLoading(false));
    };

    // Fetch all per-service Row-Settings attributes across every dashboard this
    // process is on; derive the mandatory-file-types union and the self-certify OR.
    const fetchServiceAttributes = () => {
        if (!pid) return;
        getServiceAttributesByService(pid, 'FRISCO')
            .then((result) => {
                const docs = new Set();
                let selfCertify = false;
                const attrByDashboard = {};
                (Array.isArray(result) ? result : []).forEach((d) => {
                    const attrs = d?.attributes || {};
                    if (d?.dashboard_id != null) attrByDashboard[d.dashboard_id] = attrs;
                    String(attrs.MandatorySupportingDocuments || '')
                        .split(',')
                        .map((s) => s.trim())
                        .filter(Boolean)
                        .forEach((t) => docs.add(t));
                    if (String(attrs.ShowSelfCertify || '').toLowerCase() === 'true') {
                        selfCertify = true;
                    }
                });
                setDashboardMandatoryDocs([...docs]);
                // OR'd with the app-level requireCertificationCheck where used, so a
                // later loadData response can't clobber it (no setState race).
                setDashboardSelfCertify(selfCertify);
                setDashboardServiceAttributes(attrByDashboard);
            })
            .catch((e) => {
                console.log('[ServiceAttributes] FRISCO fetch error', e);
                setDashboardMandatoryDocs([]);
                setDashboardSelfCertify(false);
                setDashboardServiceAttributes({});
            });
    };

    const changeHandler = async (inputFiles, tancSupportingFiles = []) => {
        try {
            setDisableProceedButton(true)
            if(processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift"){
                setShowLoadingIcon(true);
            }
            setErrorMessage('')
            setWarningMessage('')
            setIsFileSelected(true)
            setShowFileNotSeleted(false)
            setSelectedSheet('')
            setSupportingDocs([])
            stageSessionSelectedSheet.current = ''
            const file = inputFiles[0]
            validateFileSize(file)
            validateInputFileFormat(file)
            setUploadedFileName(file.name)

            let stageSession = uuidv4()
            stageSessionId.current = stageSession
            let fileExt = file.name.split('.').pop()
            stageSessionFileExt.current = fileExt
            let folder = `stage/${stageSession}/`
            let fileName = folder + stageSession + `.${fileExt}`
            let level = "public"
            let prefix = 'frisco/'
            configureFriscoS3()
            let putResp;

            // Determine the S3 path prefix based on encryption setting
            const encryptionEnabled = processData?.encryption_enabled === true
            const pathPrefix = encryptionEnabled
                ? `encrypted/${id}/${pid}/stage/${stageSession}/${stageSession}.${fileExt}`
                : `frisco/${fileName}`
            const supportingPathPrefix = encryptionEnabled
                ? `encrypted/${id}/${pid}/stage/${stageSessionId.current}/supportingDocuments/`
                : `frisco/stage/${stageSessionId.current}/supportingDocuments/`

            if(processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift"){
                setLoadingMessage("uploading the file, please wait...")
                try {
                    putResp = await uploadDocumentToVault(fileExt, VAULT_SERVICES.FRISCO, {"file_path": pathPrefix, "tagging": `userId=${userId}&app_id=${id}&process_id=${pid}&mappingId=${mappingId}&type=${file.type}`, "service_id":`${pid}`, "app_id":`${id}`}, file)
                } catch (uploadErr) {
                    console.error('[FriscoUpload] Vault upload FAILED:', uploadErr)
                    throw uploadErr
                }
            }
                // Validate sheets only if it is a transfer to fast redshift
            for (let i in tancSupportingFiles) {
                let supportingFile = tancSupportingFiles[i]
                let supportingFileName = supportingPathPrefix + `tanc_delta_${supportingFile.name}`
                let fileExt = supportingFileName.split('.').pop()
                let supporting = await uploadDocumentToVault(fileExt, VAULT_SERVICES.FRISCO, {"file_path": supportingFileName, "tagging": `userId=${userId}&app_id=${id}&process_id=${pid}&mappingId=${mappingId}&type=${file.type}`, "service_id":`${pid}`, "app_id":`${id}`}, supportingFile)
            }

            resetValidationErrorLogs()
            if (processData[PROCESS_KEYS.environment] === "Transfer_FAST_RedShift" && putResp && putResp.hasOwnProperty('objectKey')) {
                if (stageSessionFileExt.current == 'csv') {
                    postDataSelection()
                } else if (stageSessionFileExt.current.includes("xl") ){
                    setLoadingMessage("fetching matching sheets from the excel, please wait...")
                    onMatchResults(stageSessionId.current, function onResult(result) {
                        let response = JSON.parse(result.value.data.onMatchResults.payload)
                        let sheetsWithValidSchema = response?.validSheets?.map(colName => ({
                            label: colName,
                            value: colName
                        }))
                        setInputSheets(sheetsWithValidSchema)
                        setShowLoadingIcon(false);

                        let emptyColumnSheetsObject = response?.validationResponse?.empty_column_sheets;
                        let emptyColumnSheets = Object.keys(emptyColumnSheetsObject)
                        if (sheetsWithValidSchema.length <= 0) {
                            if (emptyColumnSheets?.length && emptyColumnSheets?.length >= 1) {
                                setErrorMessage(getBlankSheetsMessage(emptyColumnSheets, emptyColumnSheetsObject))
                            } else {
                                setErrorMessage("There are no sheets that match the required schema. Please upload valid file.")
                            }
                        } else if (sheetsWithValidSchema.length == 1) {
                            if (emptyColumnSheets?.length && emptyColumnSheets?.length >= 1) {
                                setWarningMessage(getBlankSheetsMessage(emptyColumnSheets, emptyColumnSheetsObject))
                            }
                            setSelectedSheet(sheetsWithValidSchema[0].value)
                        }
                    }, function onFailure(error) {
                        console.log(error)
                    })

                    await new Promise(resolve => setTimeout(resolve, 1000));

                    // call excel API and get sheets
                    getFRISCOPreValidationMatchingExcelSheetResults(stageSessionId.current, stageSessionFileExt.current, pid, function onSuccess(response) {
                    }, function onFailure(error) {
                        setErrorMessage("Sheet validation failed", error?.message)
                        setShowLoadingIcon(false);
                    })
                }
            }

        } catch (error) {
            console.error('[FriscoUpload] changeHandler CATCH:', error)
            setErrorMessage(error?.message)
            setLoadingMessage("")
            setShowLoadingIcon(false)
        }

    }

    const handleWbTypeChange = (value) => {
        setWbType(value)
        setPreWbFileId(null)
        setPreWbMetadata(null)
        setMainErrorMessage('')
        setActiveTabId('first')
        if (value === WB_OPTIONS.NO_POST_WB.value && allowNoPostWBResubmit) {
            setIsPreWbLoading(true)
            let quarter = corpReportingQuarter || getQuarterForUpload()
            getLatestCorpReportingUploadMetadata(id, pid, quarter, 'PreWB', function onSuccess(response) {
                const result = JSON.parse(response.data.getLatestCorpReportingUploadMetadata)
                const metadata = result?.metadata
                if (!metadata || !metadata.fileId) {
                    setMainErrorMessage('No matching Pre-WB submission found in the same quarter.')
                } else {
                    setPreWbFileId(metadata.fileId)
                    setPreWbMetadata(metadata)
                }
                setIsPreWbLoading(false)
            }, function onFailure(error) {
                setMainErrorMessage('Failed to fetch Pre-WB file metadata')
                setIsPreWbLoading(false)
            })
        }
    }

    const onSubmitClick = async () => {
        if (isFileSelected || wbType === WB_OPTIONS.NO_POST_WB.value) {
            if (shouldShowWbSelection && !wbType) {
                setMainErrorMessage('Please select a WB type before submitting.')
                return
            }
      
        // If mandatory documents to be uploaded make sure they are attached before
        // allowing them to submit. Required file types = UNION of the app-level
        // attribute AND any Task Manager dashboard's Row Settings for this service
        // (same source as the "Required file types" hint shown above).
        const requiredTypes = getRequiredDocTypes();
        let uploadedFileTypes;
        if (requiredTypes.length > 0 && wbType !== WB_OPTIONS.NO_POST_WB.value) {
            uploadedFileTypes = supportingDocs.map(file => {
                const extension = file.name.split('.').pop().toLowerCase();
                // Map file extensions to document types
                switch(extension) {
                    case 'doc':
                    case 'docx':
                        return 'Word';
                    case 'xlsm':
                    case 'xlsb':
                    case 'xls':
                    case 'xlsx':
                        return 'Excel';
                    case 'pdf':
                        return 'PDF';
                    case 'csv':
                        return 'CSV';
                    default:
                        return extension;
                }
            });
        // Check if all required types are present
        const missingTypes = requiredTypes.filter(
            type => !uploadedFileTypes.includes(type)
        );

        if (missingTypes.length > 0) {
            setMissingMandatoryDocs(missingTypes)
            return;
        }
        
    };



            try {
                // Row locking uses per-row locks, not the whole-session lock — so do NOT
                // block a row-lock submit on sessionDetails.isLocked (that legacy gate would
                // wrongly stop concurrent editors / a stale lock).
                if (!tancInfo?.rowLockingEnabled) {
                    let res = await getAssociatedTANCSessionSync(pid, 'FRISCO')
                    if (res?.items?.[0]?.isLocked && res?.items?.[0]?.lockedBy != userId) {
                        setMainErrorMessage(`File upload failed because the TANC session is locked`)
                        return
                    }
                }
            } catch (e) {

            }
            setSubmitDisabled(true)
            let quarter = null
            if (processData?.next_step == 'CORP_ADMIN_APPROVAL') {
                quarter = getQuarterForUpload()
            }
            let s3_config = getFriscoS3Config()
            let bucket_name = s3_config.S3.aws_user_files_s3_bucket
            setLoadingMessage("submitting..")
            setShowLoadingIcon(true)
            if(!stageSessionId.current && processData[PROCESS_KEYS.environment] !== "Transfer_FAST_RedShift"){
                stageSessionId.current = uuidv4()
            }

            if (supportingDocs?.length > 0) {
                setLoadingMessage("uploading supporting documents..")
                // Use encrypted prefix for supporting docs when encryption is enabled
                const encEnabled = processData?.encryption_enabled === true
                for (let i = 0; i < supportingDocs?.length; i++) {
                    const file = supportingDocs[i]
                    let fileExt = file.name.split('.').pop()
                    let folder = `stage/${stageSessionId.current}/supportingDocuments/`
                    let fileName = folder + file.name
                    const supportDocPath = encEnabled
                        ? `encrypted/${id}/${pid}/stage/${stageSessionId.current}/supportingDocuments/${file.name}`
                        : `frisco/${fileName}`

                    let putResp = await uploadDocumentToVault(fileExt, VAULT_SERVICES.FRISCO, {"file_path": supportDocPath, "tagging": `userId=${userId}&app_id=${id}&process_id=${pid}&mappingId=${mappingId}&type=${file.type}`, "service_id":`${pid}`, "app_id":`${id}`}, file)
                }
            }
            setLoadingMessage("submitting the request..")
            // Self-certification proof: logged on the transaction record only when the
            // certify checkbox was required (app-level or dashboard ShowSelfCertify,
            // with reviewers/approvers present) AND actually ticked. Applies to both
            // the resubmit (NoPostWB) and normal submit paths below.
            const isSelfCertified =
                (requireCertificationCheck || dashboardSelfCertify) &&
                approverNames?.length > 0 &&
                certificationChecked
            // On the NoPostWB resubmit path no new file is selected, so uploadedFileName
            // is empty/stale — use the name of the Pre-WB file actually being resubmitted.
            const isNoPostWBResubmit =
                wbType === WB_OPTIONS.NO_POST_WB.value && allowNoPostWBResubmit && preWbFileId
            const certFileName = isNoPostWBResubmit
                ? (preWbMetadata?.uploadedFileName || uploadedFileName)
                : uploadedFileName
            const selfCertification = isSelfCertified ? {
                user: userId,
                time: String(Date.now()),
                fileName: certFileName,
                reviewers: approverNames.filter((a) => a.column_index === 0).map((a) => a.alias),
                approvers: approverNames.filter((a) => a.column_index === 1).map((a) => a.alias),
                wbVersion: wbType || null,
            } : null
            if (wbType === WB_OPTIONS.NO_POST_WB.value && allowNoPostWBResubmit && preWbFileId) {
                friscoResubmit({ fileId: preWbFileId, quarter: corpReportingQuarter || getQuarterForUpload(), wbType: wbType, uploadedTimestamp: String(Date.now()), uploadedBy: userId, selfCertification: selfCertification },
                function onSuccess(response) {
                    setFileReference(JSON.parse(response.data.friscoResubmit)?.fileId)
                    setShowSuccessModal(true)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                    setWbType(null)
                    setPreWbFileId(null)
                    setSupportingDocs([])
                }, function onFailure(response) {
                    setMainErrorMessage(`File upload failed`)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                })
            } else if (tancInfo?.rowLockingEnabled && uploadSegment == 'tanc') {
            // FRISCO row locking — Step 3, the user CONFIRMED. ONLY NOW do we write to
            // TANCRowLock: flip each held row EDITING→SUBMITTED (carry the delta key from
            // Step 1; mark deleted rows pendingDelete), THEN fire the orchestrator, which
            // rebases the merged truth and hands it to the EXISTING ingest. Deliberately
            // NO whole-session lockSession('TANC'): per-row locks stay held
            // (SUBMITTED→PROCESSING→PENDING_FRISCO_INGEST) until the post-ingest sync
            // (clear_cache) releases them once the truth file is updated. Nothing was
            // committed before this point, so cancelling at Review leaves rows EDITING.
            const info = rowLockSubmitRef.current || {}
            const heldIds = info.heldIds || []
            if (heldIds.length === 0) {
                setMainErrorMessage('Nothing to submit — please make an edit first.')
                setShowLoadingIcon(false)
                setSubmitDisabled(false)
                return
            }
            const deletedIds = new Set(info.deletedIds || [])
            const tid = String(sessionDetails.tancId || '')
            console.log(`[RowLock] step3 confirm → flipping ${heldIds.length} row(s) EDITING→SUBMITTED then tancSubmitRebase session=${sessionDetails.sessionId}`)
            // Mark confirmed BEFORE flipping: once rows are SUBMITTED and the rebase is in
            // flight, a Cancel must NOT release them out from under the orchestrator (which
            // claims SUBMITTED→PROCESSING a few seconds later). releaseTancRowLocksOnCancel
            // checks this flag. Reset to false on any failure so cancel can roll back.
            submitConfirmedRef.current = true
            Promise.allSettled(heldIds.map(rid => new Promise((resolve, reject) => {
                tancRowLockEvent(sessionDetails.sessionId, tid, rid, 'SUBMITTED', info.deltaKey, deletedIds.has(rid), resolve, reject, info.comment)
            }))).then((results) => {
                if (results.some(r => r.status === 'rejected')) {
                    // Partial flip: put flipped rows back to EDITING (still ours), else a peer's
                    // next rebase or the drain would ingest part of a submit we report as failed.
                    const flipped = heldIds.filter((_, i) => results[i].status === 'fulfilled')
                    console.log(`[RowLock] step3 partial flip: rolling ${flipped.length} row(s) back to EDITING session=${sessionDetails.sessionId}`)
                    flipped.forEach(rid => tancRowLockEvent(sessionDetails.sessionId, tid, rid, 'EDITING'))
                    throw new Error('partial SUBMITTED flip')
                }
            }).then(() => {
                tancSubmitRebase(sessionDetails.sessionId,
                    function onSuccess(response) {
                        // No upload fileId to show (the ingest file is generated server-side
                        // in the orchestrator handoff); surface the session id as the reference.
                        setFileReference(sessionDetails.sessionId)
                        setShowSuccessModal(true)
                        setShowLoadingIcon(false)
                        setSubmitDisabled(false)
                        setWbType(null)
                        setSupportingDocs([])
                        rowLockSubmitRef.current = null
                    }, function onFailure(response) {
                        submitConfirmedRef.current = false
                        setMainErrorMessage(`Submit failed`)
                        setShowLoadingIcon(false)
                        setSubmitDisabled(false)
                    })
            }).catch(() => {
                // A row failed to reach SUBMITTED → do NOT rebase (the orchestrator would
                // miss that row and silently drop its edit). Surface the error and re-allow cancel.
                submitConfirmedRef.current = false
                setMainErrorMessage('Submit failed — another user now holds a row you changed. Nothing was submitted; cancel and redo your changes.')
                setShowLoadingIcon(false)
                setSubmitDisabled(false)
            })
            } else {
            friscoSubmit(stageSessionId.current, id, pid, FRISCO_STATUS.UPLOADED, bucket_name, uploadedFileName, stageSessionFileExt.current,
                Date.now(), userId, uploadedFileName, stageSessionSelectedSheet.current, quarter, taskId, null, null, wbType, taskManagerInputs, selfCertification,
                function onSuccess(response) {
                    setFileReference(JSON.parse(response.data.friscoSubmit)?.fileId)
                    setShowSuccessModal(true)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                    setWbType(null)
                    setSupportingDocs([])
                    if (tancInfo?.status) {
                        lockSession('TANC')
                    }
                }, function onFailure(response) {
                    setMainErrorMessage(`File upload failed, fileId : ${sessionId}`)
                    setShowLoadingIcon(false)
                    setSubmitDisabled(false)
                })
            }
        }

    }

    const unlockSession = (message = "Releasing lock for the session from Accounting central") => {
        if (sessionDetails?.sessionId) {
            createAuditLog(`TANC_SESSION#${sessionDetails.sessionId}`, `UNLOCK_SESSION#${Date.now()}`, message, JSON.stringify(sessionDetails), null, "TANK UNLOCK SESSION ON UI", userId)
            updateTANCLock(sessionDetails.sessionId, false, null, null, function onSuccess(response) {
                setSessionDetails({ ...sessionDetails, isLocked: response?.data?.updateTANCLock?.isLocked, lockedBy: response?.data?.updateTANCLock?.lockedBy })
            }, function onFailure(response) {
                setAnnotationError("Failed to unlock!")
            })
        }
    }

    const lockSession = (alias = userId) => {
        if (sessionDetails?.sessionId) {
            createAuditLog(`TANC_SESSION#${sessionDetails.sessionId}`, `LOCK_SESSION#${Date.now()}`, "Acquiring lock for the session from Accounting central via upload", JSON.stringify(sessionDetails), null, "TANK LOCK SESSION ON UI UPLOAD", userId)
            updateTANCLock(sessionDetails.sessionId, true, alias, "Uploading data", function onSuccess(response) {
                setSessionDetails({ ...sessionDetails, isLocked: response?.data?.updateTANCLock?.isLocked, lockedBy: response?.data?.updateTANCLock?.lockedBy })
            }, function onFailure(response) {
                setAnnotationError("Failed to lock!")
            })
        }
    }

    const prevButtonClick = () => {
        setActiveTabId('first')
        setShowSuccessModal(false)
        setDisableProceedButton(false)
        // unlock session if any
        unlockSession("Releasing lock after clicking cancel in FRISCO upload page")
    }

    // Row locking: on cancel from ANY wizard step (Review / Submit), release the
    // per-row locks THIS user still holds for the session so a cancelled edit or submit
    // never leaves a row greyed for peers until TTL. Reads the locks BY SESSION (not the
    // grid's in-memory set) so it works even from steps where the TANC grid is unmounted.
    // Only EDITING/SUBMITTED rows are released — a row already handed to the orchestrator
    // (PROCESSING/PENDING_FRISCO_INGEST) is mid-ingest and is left to its own lifecycle.
    const releaseTancRowLocksOnCancel = async () => {
        if (!tancInfo?.rowLockingEnabled || !sessionDetails?.sessionId) return;
        try {
            const locks = await getRowLocksForSession(sessionDetails.sessionId);
            // After a confirmed submit, SUBMITTED rows are in flight (rebase fired, orchestrator
            // about to claim them) — releasing them would drop the submit. So only free EDITING
            // rows once confirmed; before confirm, free EDITING + SUBMITTED (abandoned edit).
            const releasableStates = submitConfirmedRef.current
                ? ['EDITING']
                : ['EDITING', 'SUBMITTED'];
            const mine = (locks || []).filter(l =>
                l?.internal_tanc_identifier && l?.lockedBy === userId &&
                releasableStates.includes(l?.tanc_lock_state));
            console.log(`[RowLock] cancel release: freeing ${mine.length} held row(s) (states=${releasableStates}) session=${sessionDetails.sessionId}`);
            mine.forEach(l => tancRowLockEvent(sessionDetails.sessionId, String(sessionDetails.tancId || ''), l.internal_tanc_identifier, 'RELEASE'));
        } catch (e) {
            console.log(`[RowLock] cancel release failed session=${sessionDetails?.sessionId}: ${e}`);
        }
    };

    const cancelButtonClick = () => {
        // Free any per-row locks this user holds BEFORE resetting local state (row-lock
        // sessions only; no-op otherwise). Fire-and-forget so the UI resets immediately.
        releaseTancRowLocksOnCancel()
        rowLockSubmitRef.current = null  // Cancel = discard; Back (prevButtonClick) keeps the draft
        setActiveTabId('first')
        setShowSuccessModal(false)
        setIsFileSelected(false)
        setInputFiles([])
        setSelectedSheet('')
        setInputSheets([])
        setMainErrorMessage('')
        stageSessionFileExt.current = null
        stageSessionId.current = null
        setDisableProceedButton(false)

        // unlock session if any
        unlockSession("Releasing lock after clicking cancel in FRISCO upload page")
    }

    const next1Click = () => {

        setActiveTabId('third')

    }

    const ModalOkClick = () => {
        // Dispatch submit trigger for pulse survey notifications
        dispatch(setPendingTrigger(ActionTriggerType.SUBMIT));
        // Check if we have sidebar content (query parameter context)
        if (props.selectedSidebarContent) {
            // Find the History tab and trigger its action
            const historyTab = props.selectedSidebarContent.find(
                tab => tab.label.toLowerCase() === 'history'
            );
            
            if (historyTab && historyTab.action) {
                // Close the modal first
                setShowSuccessModal(false);
                // Trigger the History tab action (updates parent state + URL)
                historyTab.action();
            } else {
                // Fallback if History tab not found
                setShowSuccessModal(false);
                history.push(`/App/${id}/process/${pid}/history${location.search}`);
            }
        } else {
            // Fallback to original behavior if not in query parameter context
            history.push(`/App/${id}/process/${pid}/history${location.search}`);
        }
    }


    const getSupportedFormats = (input = processData, defValue = '.csv') => {
        let returnValue = new Set()
        returnValue.add(defValue)
        if (input && input.hasOwnProperty(PROCESS_KEYS.file_types) && input[PROCESS_KEYS.file_types]) {
            input[PROCESS_KEYS.file_types].forEach((item) => {
                if (item == 'CSV') {
                    returnValue.add('.csv')
                } else if (item == 'Excel') {
                    returnValue.add('.xls')
                    returnValue.add('.xlsx')
                    returnValue.add('.xlsb')
                    returnValue.add('.xlsm')
                    // returnValue.add('.xltx')
                    // returnValue.add('.xltm')
                } else if( item === 'PDF'){
                    returnValue.add(".pdf")
                } else if( item === 'Word'){
                    returnValue.add(".docx")
                    returnValue.add(".docm")
                    returnValue.add(".doc")
                } 
            })
        }
        return Array.from(returnValue).join(",")
    }
    const onFollowHandler = (ev) => {
        ev.preventDefault();
        if (ev.detail.href) {
            history.push(ev.detail.href);
        }
    }

    function getTempFile(data, fileName = `updated`) {
        // Remove specific columns
        const lines = data.split('\n');
        const headers = lines[0].split(',').map(h => h.replace(/["]/g, '').trim());
        const columnsToRemove = ['frisco_fast_load_ts', 'file_id'];
        const removeIndices = columnsToRemove.map(col => headers.indexOf(col)).filter(i => i !== -1);

        const keepIndices = headers.map((_, i) => i).filter(i =>
            !columnsToRemove.includes(headers[i])
        );

        const filteredData = lines.map(line => {
            const cols = line.split(',');
            return keepIndices.map(i => cols[i] || '').join(',');
        }).join('\n');


        const blob = new Blob([filteredData], { type: 'text/csv' });
        const tempFile = new File([blob], `${fileName}.csv`, { type: 'text/csv' });
        return tempFile
    }

    async function tancSubmit(data, dataAltered, fileName, rowLockSubmit) {
        // Row-lock sessions pass rowLockSubmit (Step-1 staged delta + the rows/deletions
        // to commit at Step 3): stash it and DO NOT take the whole-session lock — per-row
        // locks are used instead, and SUBMITTED isn't written until Step 3. Legacy sessions
        // (no rowLockSubmit) lock the session as before. Everything else is identical:
        // getTempFile + changeHandler advance the wizard to Review.
        if (rowLockSubmit) {
            rowLockSubmitRef.current = rowLockSubmit
        } else {
            lockSession()
        }
        let tempFile = getTempFile(data, fileName)
        let tempFileAltered = getTempFile(dataAltered, `${fileName}_${Date.now().toString()}`)
        changeHandler([tempFile], [tempFileAltered]);
    }

    function tancSubmitAltered(data, fileName, rowLockSubmit) {
        // Same row-lock handling as tancSubmit (DELSERT path uses this).
        if (rowLockSubmit) {
            rowLockSubmitRef.current = rowLockSubmit
        } else {
            lockSession()
        }
        let tempFile = getTempFile(data, fileName)
        changeHandler([tempFile], [tempFile]);
    }

    // Process Comment Functions using custom_attributes
    const handleProcessCommentUpdate = (commentText, onSuccess, onFailure) => {
        setIsCommentSubmitting(true);
        updateProcessComment(
            pid, 
            commentText, 
            userId,
            (result) => {
                // Success callback - reload process data to get updated comment
                setIsCommentSubmitting(false);
                loadData();
                if (onSuccess) {
                    onSuccess(result);
                }
            },
            (error) => {
                // Failure callback
                setIsCommentSubmitting(false);
                console.error('Error updating process comment:', error);
                if (onFailure) {
                    onFailure(error);
                }
            }
        );
    };

    // Required supporting-doc file types shown to the uploader = UNION of the
    // app-level MandatorySupportingDocuments attribute AND the Task Manager
    // dashboards' Row Settings (dashboardMandatoryDocs). Kept in one place so the
    // displayed hint matches what submit actually enforces.
    // Only meaningful when the supporting-doc upload UI is shown; otherwise there
    // is no way to attach files, so enforcing mandatory docs would dead-end the
    // uploader at submit. Returns [] when upload is disabled.
    const getRequiredDocTypes = () => {
        if (!shouldShowPdfUpload) return [];
        const appDocs = (
            processData?.custom_attributes?.find(
                attr => attr.attribute_type === 'MandatorySupportingDocuments'
            )?.attribute || ''
        ).split(',').map(s => s.trim()).filter(Boolean);
        return [...new Set([...appDocs, ...dashboardMandatoryDocs])];
    };

    // Attach each required DATE column's stored datetime, read from the service's
    // per-dashboard attribute map (service_attributes are keyed by column name).
    // Keeps the value on the FE so no extra backend field is needed.
    const requiredDateDashboardsWithValues = (Array.isArray(requiredDateDashboards) ? requiredDateDashboards : [])
        .map(d => {
            const attrs = dashboardServiceAttributes?.[d?.dashboard_id] || {};
            return {
                ...d,
                date_columns: (Array.isArray(d?.date_columns) ? d.date_columns : []).map(col => {
                    const name = typeof col === 'string' ? col : col?.name;
                    return typeof col === 'string'
                        ? { name: col, due_date_type: col, value: attrs[col] || '' }
                        : { ...col, value: attrs[name] || '' };
                }),
            };
        });

    // Every Task Manager dashboard that exposes required date fields must have one
    // option picked before submit (mirrors the mandatory Pre/Post WB radio).
    // .every on an empty list is true, so no required dates => complete.
    const dashboardsWithRequiredDates = requiredDateDashboardsWithValues
        .filter(d => Array.isArray(d?.date_columns) && d.date_columns.length > 0);
    const requiredDatesComplete = dashboardsWithRequiredDates.every(d => {
        const sel = taskManagerInputs?.[d.dashboard_id];
        return sel && Array.isArray(sel.dates) && sel.dates.length > 0;
    });

    const renderCertificationSection = (showTitle = false) => {
        if (!(requireCertificationCheck || dashboardSelfCertify)) return null;
        
        return (
            <Alert statusIconAriaLabel="Info" header="">
                {showTitle && <Box variant='h5'>Certification</Box>}
                <Checkbox
                    onChange={({ detail }) => setCertificationChecked(detail.checked)}
                    checked={certificationChecked}
                >
                    <strong>I, {userId} (uploader), certify that the deliverable has been reviewed by {approverNames.filter(item => item.column_index === 0).map(item => item.alias).join(', ')} (reviewer) and approved by {approverNames.filter(item => item.column_index === 1).map(item => item.alias).join(', ')} (approver).</strong>
                </Checkbox>
            </Alert>
        );
    };

    const friscoUploadView = (
        <ColumnLayout borders="vertical" columns={2} >
            <SpaceBetween direction='vertical' size='m'>
                {tancInfo?.status && (
                    <Alert type='error'>
                        Making a new upload will override changes made to the current version via the 'Edit in UI' tab. 
                        Please consider whether this is your intention before proceeding.
                    </Alert>
                )}
                {showFileNotSeleted ? <Alert type='error'>File Not Selected</Alert> : ''}
                {
                    showUploadBtn ? <FileUpload
                        onChange={({ detail }) => {
                            const sanitizedFiles = sanitizeFiles(detail.value);
                            setInputFiles(sanitizedFiles);
                            setSelectedSheet(''); setInputSheets([]);
                            changeHandler(sanitizedFiles)
                        }}
                        value={inputFiles}
                        i18nStrings={{
                            uploadButtonText: e =>
                                e ? "Choose files" : "Choose file",
                            dropzoneText: e =>
                                e
                                    ? "Drop files to generate"
                                    : "Drop file to generate",
                            removeFileAriaLabel: e =>
                                `Remove file ${e + 1}`,
                            limitShowFewer: "Show fewer files",
                            limitShowMore: "Show more files",
                            errorIconAriaLabel: "Error"
                        }}
                        showFileLastModified
                        showFileSize
                        showFileThumbnail
                        tokenLimit={1}
                        accept={supportedFormats}
                        constraintText="upload input file"
                    /> : <Box></Box>
                }
                {inputSheets && inputSheets.length > 0 ?
                    <SpaceBetween size='s'>
                        <Box variant='h5'> Please choose a sheet from the uploaded file for processing, and click proceed</Box>
                        <Tiles
                            onChange={({ detail }) => {
                                setSelectedSheet(detail.value)
                            }}
                            value={selectedSheet}
                            items={inputSheets}
                        />
                    </SpaceBetween> : <></>
                }
                { processData && processData?.file_types && processData.file_types.length >0 &&
                    <Alert
                        statusIconAriaLabel="Info"
                        header="Allowed File Upload Types"
                    >
                        The following file types are allowed for Upload:
                        <ul>
                            {processData.file_types.map(fileType => <li key={fileType}>{fileType}</li>)}
                        </ul>
                    </Alert>
                }
                {inputSheets && inputSheets.length >0 && (
                    <Box float="right">
                        <Button variant="primary" disabled={disableProceedButton || (shouldShowWbSelection && !wbType)} onClick={processExcelSheet} >Proceed</Button>
                    </Box>
                )}

                {
                    comments ? <Alert
                        statusIconAriaLabel="Info"
                        header="Dates"
                    >
                        {comments?.split("\n")?.map((t, key) => {
                            return <p key={key}>{t}</p>;
                        })}


                    </Alert> : ''
                }

                {errorMessage ? <Alert statusIconAriaLabel="Error"
                    type="error"
                    header="Upload restricted">
                    {errorMessage}
                    {renderFileErrorDisclaimer()}
                </Alert> : ''}

                {warningMessage ? <Alert statusIconAriaLabel="Warning"
                    type="warning"
                    header="Upload restricted">
                        {warningMessage}
                </Alert> : ''}

                {
                    emptyColumnIndices?.length > 0 && <Alert type="error">
                        Empty columns found. Column index: {emptyColumnIndices?.join(',')}
                    </Alert>
                }


                {(missingFields?.size >= 1 || colCountMoreThanExpected || colsNotInRequiredOrder || Object.keys(comparisonValidationErrors).length > 0 || Object.keys(nonEmptyColumnErrors).length > 0) ? (
                    <>
                        <Box>
                            <h4>Validation checks:</h4>
                            <ul>
                                <li>
                                    All required fields available? {missingFields.size >= 1 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Provided column(s) count is less than or equal to expected column count? {colCountMoreThanExpected ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Empty column(s) name found? {emptyColumnIndices?.length > 0 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Column order as expected? (Please refer required column order on the right) {colsNotInRequiredOrder ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Column value validation passed? {Object.keys(comparisonValidationErrors).length > 0 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                                <li>
                                    Non-empty column validation passed? {Object.keys(nonEmptyColumnErrors).length > 0 ? <Icon name="status-negative" variant="error" /> : <Icon name="status-positive" variant="success" />}
                                </li>
                            </ul>
                        </Box>
                        {
                            (missingFields.size >= 1 &&

                                <Alert
                                    statusIconAriaLabel="Error"
                                    type="error"
                                    header="Required fields are missing"
                                >
                                    {renderDataErrorDisclaimer()}
                                    <SpaceBetween>
                                        <Box><h4>Missing columns:</h4>
                                            <ul>
                                                {Array.from(missingFields).map((field) => (
                                                    <li key={field}>{field}</li>
                                                ))}
                                            </ul>
                                        </Box>
                                        <Box><h4>Provided columns:</h4>
                                            <ul>
                                                {providedCoulumns.map((field) => (
                                                    <li key={field}>{field}</li>
                                                ))}
                                            </ul>
                                        </Box>
                                    </SpaceBetween>
                                </Alert>
                            )
                        }
                        {
                            (Object.keys(comparisonValidationErrors).length > 0 &&
                                <Alert
                                    statusIconAriaLabel="Error"
                                    type="error"
                                    header="Column value validation failed"
                                >
                                    {renderDataErrorDisclaimer()}
                                    <SpaceBetween>
                                        {Object.entries(comparisonValidationErrors).map(([columnName, errors]) => (
                                            <Box key={columnName}>
                                                <h4>Column: {columnName}</h4>
                                                <p>Expected all values to be: <strong>{errors[0]?.expected_value}</strong></p>
                                                <p>Found {errors.length} row(s) with incorrect values:</p>
                                                <ul>
                                                    {errors.slice(0, 10).map((error, index) => (
                                                        <li key={index}>
                                                            Row {error.row_index}: "{error.actual_value}" (expected "{error.expected_value}")
                                                        </li>
                                                    ))}
                                                    {errors.length > 10 && (
                                                        <li>... and {errors.length - 10} more rows with validation errors</li>
                                                    )}
                                                </ul>
                                            </Box>
                                        ))}
                                    </SpaceBetween>
                                </Alert>
                            )
                        }
                        {
                            (Object.keys(nonEmptyColumnErrors).length > 0 &&
                                <Alert
                                    statusIconAriaLabel="Error"
                                    type="error"
                                    header="Non-empty column validation failed"
                                >
                                    <SpaceBetween>
                                        {Object.entries(nonEmptyColumnErrors).map(([columnName, errors]) => (
                                            <Box key={columnName}>
                                                <p>Column <strong>{columnName}</strong> requires a value for each row.</p>
                                                <p>Found {errors.length} row(s) with empty values:</p>
                                                <ul>
                                                    {errors.slice(0, 10).map((error, index) => (
                                                        <li key={index}>
                                                            Row {error.row_index + 1}
                                                        </li>
                                                    ))}
                                                    {errors.length > 10 && (
                                                        <li>... and {errors.length - 10} more rows with empty values</li>
                                                    )}
                                                </ul>
                                            </Box>
                                        ))}
                                    </SpaceBetween>
                                </Alert>
                            )
                        }
                        {
                            providedCoulumns.length > 0 ?
                                <SpaceBetween>

                                </SpaceBetween>
                                : <></>
                        }


                    </>
                ) : <></>

                }

            </SpaceBetween>





            {processData[PROCESS_KEYS.environment] == "Transfer_FAST_RedShift" &&(
                <Box>
                    <ExpandableSection header="The file should contain the following columns in below order."
                        defaultExpanded>
                        <ColumnLayout columns={2}>
                            <SpaceBetween direction='vertical'>
                                <Box variant="awsui-key-label" > &nbsp;</Box>
                                <ul>
                                    {
                                        Array.from(getMandatoryColumnNames()).map(
                                            column => <li
                                                value={column}
                                                key={column}>
                                                <span>{column}</span>
                                                <span className='missing'> {(missingFields && missingFields.size > 0 && missingFields.has(column)) ? ' - required' : ''} </span>
                                            </li>
                                        )
                                    }
                                </ul>
                            </SpaceBetween>

                            {
                                providedCoulumns.length > 0 ?
                                    <SpaceBetween direction='vertical'>
                                        <Box variant="awsui-key-label" >Provided columns</Box>
                                        <ul>
                                            {
                                                Array.from(providedCoulumns).map(
                                                    column => <li
                                                        value={column}
                                                        key={column}>
                                                        <span>{column}</span>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </SpaceBetween> : <></>
                            }
                        </ColumnLayout>
                    </ExpandableSection>
                </Box>
            )}
        </ColumnLayout>
    )

    const getUploadTabs = () =>{
        const environment = processData[PROCESS_KEYS.environment]
        let tabs = []
        
        if(environment === 'Transfer_FAST_RedShift'){
            const isNoPostWB = wbType === WB_OPTIONS.NO_POST_WB.value

            tabs.push(
                {
                    activeTabId: { activeTabId },
                    label: isNoPostWB ? `Step 1 : Select WB Type and Submit` : `Step 1 : Upload File`,
                    id: "first",
                    content: (
                        <div>
                            <SpaceBetween direction='vertical' size='l'>
                                {
                                    shouldShowWbSelection &&
                                        <RadioGroup
                                            onChange={({ detail }) => handleWbTypeChange(detail.value)}
                                            value={wbType}
                                            items={getFilteredWbOptionsPlugin(processData)}
                                        />
                                }
                                {
                                    !isNoPostWB &&
                                    <SpaceBetween direction='vertical'>
                                        {
                                            uploadSegment == 'tanc' ? <TANCSession sessionDetails={sessionDetails} tancDetails={tancInfo} showSave={false} showSubmit={true} pendingRowLockDraft={rowLockSubmitRef.current?.draft} onDiscardRowLockDraft={() => { rowLockSubmitRef.current = null }} onSubmit={tancSubmit} ></TANCSession> : <Box><br></br> {friscoUploadView}</Box>
                                        }
                                    </SpaceBetween>
                                }
                                {
                                    isNoPostWB &&
                                    <SpaceBetween direction='vertical' size='m'>
                                        {mainErrorMessage && (
                                            <Alert type="error" header="Error">
                                                {mainErrorMessage}
                                            </Alert>
                                        )}
                                        <Alert type="warning" header="Important Notice">
                                            You have indicated no change in the deliverable since Pre-WB version. Ensure this is accurate before submitting.
                                            {
                                                allowNoPostWBResubmit && preWbMetadata && 
                                                    <>
                                                        <br/>
                                                        <br/>
                                                        You will be re-submitting the file uploaded on {moment(parseInt(preWbMetadata.uploadedTimestamp)).format('MMM DD, YYYY')} named {preWbMetadata.uploadedFileName}
                                                    </>
                                            }
                                        </Alert>
                                        {
                                            approverNames?.length > 0 && (
                                                <SpaceBetween direction='vertical' size='m'>
                                                    {renderCertificationSection()}
                                                </SpaceBetween>
                                            )
                                        }
                                        <RequiredDateColumns
                                            dashboards={requiredDateDashboardsWithValues}
                                            loading={requiredDateLoading}
                                            error={requiredDateError}
                                            onSelectionChange={setTaskManagerInputs}
                                        />
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <Button variant="normal" onClick={cancelButtonClick} disabled={submitDisabled}>Cancel</Button>
                                            <Button variant="primary" onClick={onSubmitClick} disabled={submitDisabled || (allowNoPostWBResubmit && !preWbFileId) || ((requireCertificationCheck || dashboardSelfCertify) && approverNames?.length > 0 && !certificationChecked) || requiredDateLoading || !!requiredDateError || !requiredDatesComplete} loading={isPreWbLoading}>Submit</Button>
                                        </SpaceBetween>
                                    </SpaceBetween>
                                }
                            </SpaceBetween>
                        </div>
                    )
                }
            )

            if (!isNoPostWB) {
            tabs.push(
                {
                    label: currentAppId == appSettings[currentStage]['appId'] ? "Step 2 : Validate Datasheet" : "Step 2 : Review File",
                    id: "second",
                    content: (
                        <Box>
                            <Header
                                variant="h2"
                                description="File preview - Read Only"
                                actions={
                                    <SpaceBetween
                                        direction="horizontal"
                                        size="xs"
                                    >
                                        <Button variant="normal" onClick={prevButtonClick}>Previous</Button>
                                        <Button variant="primary" onClick={next1Click}>Next</Button>
                                        <Box></Box>
                                    </SpaceBetween>
                                }
                            />
                            <br />
                            <SpaceBetween direction='vertical' size='m'>
                                <Alert type="info">
                                    Please review your upload for accuracy before proceeding to next step
                                </Alert>
                                {
                                    emptyRowsValidationResult?.has_empty_rows && <Alert type="warning">
                                        There are {emptyRowsValidationResult?.count} empty row(s) in the input.
                                    </Alert>
                                }
                            </SpaceBetween>
                            <br />
                            <Table
                                columnDefinitions={columnsList}
                                items={previewItems}
                                stickyHeader={true}
                                resizableColumns={true}
                            >
                            </Table>
                        </Box>
                    )
                }
            )
            
            tabs.push(
                {
                    label: currentAppId == appSettings[currentStage]['appId'] ? "Step 3 : Upload Supporting Files and Submit" : "Step 3 : Submit",
                    id: "third",
                    content: (<div>
                        <Header
                            variant="h2"
                            description="Upload Details"
                        />
                        <SpaceBetween direction='vertical' size='l'>
                            <Box>
                                Filename: {uploadedFileName}
                                {mainErrorMessage && (
                                    <div className="custom-new-upload__error-message"> {mainErrorMessage} </div>
                                )}
                            </Box>
                                {
                                    shouldShowPdfUpload ?
                                        <SpaceBetween size="s">
                                                                <FileInput
                                                                    onChange={({ detail }) => {
                                                                        const sanitizedFiles = sanitizeFiles(detail.value);
                                                                        setSupportingDocs([...supportingDocs, ...sanitizedFiles])
                                                                        setMissingMandatoryDocs([])
                                                                    }}
                                                value={supportingDocs}
                                                multiple
                                            >
                                                Upload supporting documents
                                            </FileInput>
                                            <Table
                                                columnDefinitions={[
                                                    {
                                                        id: "name",
                                                        header: "File name",
                                                        cell: file => file.name
                                                    },
                                                    {
                                                        id: "size",
                                                        header: "File size",
                                                        cell: file => file.size / 1000 + "KB"
                                                    },
                                                    {
                                                        id: "delete",
                                                        header: "",
                                                        cell: (file) => (
                                                        <Button
                                                            iconName="close"
                                                            variant="icon"
                                                            onClick={() => {
                                                                setSupportingDocs((currentDocs) =>
                                                                currentDocs.filter((doc) => doc !== file)
                                                                );
                                                            }}
                                                            ariaLabel={`Delete ${file.name}`}
                                                        />
                                                    )}
                                                ]}
                                                items={supportingDocs}
                                                empty="No files"
                                            />
                                            <br/>
                                            {  getRequiredDocTypes().length > 0  &&
                                                <Alert
                                                    statusIconAriaLabel="Info"
                                                    header="Required file types"
                                                >
                                                    Please upload the following types files: 
                                                    <ul>
                                                        {getRequiredDocTypes().map((field) => (
                                                            <li key={field}>{field}</li>
                                                        ))}
                                                    </ul>
                                                </Alert>
                                            }
                                            {
                                                (missingMandatoryDocs.length >= 1 &&
                                                    <Alert
                                                        statusIconAriaLabel="Error"
                                                        type="error"
                                                        header="Required file types are missing"
                                                    >
                                                        <SpaceBetween>
                                                            <Box><h4>Missing file types:</h4>
                                                                <ul>
                                                                    {Array.from(missingMandatoryDocs).map((field) => (
                                                                        <li key={field}>{field}</li>
                                                                    ))}
                                                                </ul>
                                                            </Box>
                                                        </SpaceBetween>
                                                    </Alert>
                                                )
                                            }
                                        </SpaceBetween> : <></>
                                }
                                {
                                    approverNames?.length > 0 && (
                                        <SpaceBetween direction='vertical' size='m'>
                                        {renderCertificationSection()}
                                    </SpaceBetween>
                            )}
                    </SpaceBetween>
                    <br/>
                        <RequiredDateColumns
                            dashboards={requiredDateDashboardsWithValues}
                            loading={requiredDateLoading}
                            error={requiredDateError}
                            onSelectionChange={setTaskManagerInputs}
                        />
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="normal" onClick={cancelButtonClick} disabled={submitDisabled}>Cancel</Button>
                            <Button variant="primary" onClick={onSubmitClick} disabled={submitDisabled || (shouldShowWbSelection && !wbType) || ((requireCertificationCheck || dashboardSelfCertify) && approverNames?.length > 0 && !certificationChecked) || requiredDateLoading || !!requiredDateError || !requiredDatesComplete} loading={isPreWbLoading}>Submit</Button>
                        </SpaceBetween>
                    </div>)
                }
            )
            } // end !isNoPostWB
        } else {
            // Single tab with all content for non-Transfer_FAST_RedShift environments
            tabs.push(
                {
                    activeTabId: { activeTabId },
                    label: `Upload and Submit`,
                    id: "first",
                    content: (
                        <div>
                            <SpaceBetween direction='vertical' size='l'>
                                <>{errorsContent}</>
                                {
                                    uploadSegment == 'tanc' ? <TANCSession sessionDetails={sessionDetails} tancDetails={tancInfo} showSave={false} showSubmit={true} pendingRowLockDraft={rowLockSubmitRef.current?.draft} onDiscardRowLockDraft={() => { rowLockSubmitRef.current = null }} onSubmit={processData[PROCESS_KEYS.action] == 'DELSERT' ? null : tancSubmit} onSubmitAltered={processData[PROCESS_KEYS.action] == 'DELSERT' ? tancSubmitAltered : null}></TANCSession> :
                                    <SpaceBetween direction='vertical' size='l'>
                                        <Container
                                            header={
                                                <Header
                                                    variant="h3"
                                                    description="File Details"
                                                />
                                            }
                                        >
                                            <SpaceBetween direction='vertical' size='l'>
                                                <Box>
                                                    {mainErrorMessage && (
                                                        <div className="custom-new-upload__error-message"> {mainErrorMessage} </div>
                                                    )}
                                                </Box>
                                                    {
                                                        shouldShowWbSelection ?
                                                            <RadioGroup
                                                                onChange={({ detail }) => handleWbTypeChange(detail.value)}
                                                                value={wbType}
                                                                items={getFilteredWbOptionsPlugin(processData)}
                                                            /> : <></>
                                                    }
                                                    {
                                                        wbType === WB_OPTIONS.NO_POST_WB.value && <Alert type="warning" header="Important Notice">
                                                            You have indicated no change in the deliverable since Pre-WB version. Ensure this is accurate before submitting.
                                                            {
                                                                allowNoPostWBResubmit && preWbMetadata && 
                                                                    <>
                                                                        <br/>
                                                                        <br/>
                                                                        You will be re-submitting the file uploaded on {moment(parseInt(preWbMetadata.uploadedTimestamp)).format('MMM DD, YYYY')} named {preWbMetadata.uploadedFileName}
                                                                    </>
                                                            }
                                                        </Alert>
                                                    }
                                                    {
                                                        shouldShowPdfUpload && wbType !== WB_OPTIONS.NO_POST_WB.value && (!shouldShowWbSelection || wbType) ?
                                                            <SpaceBetween size="s">
                                                                <FileInput
                                                                    onChange={({ detail }) => {
                                                                        const sanitizedFiles = sanitizeFiles(detail.value);
                                                                        setSupportingDocs([...supportingDocs, ...sanitizedFiles])
                                                                        setMissingMandatoryDocs([])
                                                                        if (sanitizedFiles.length > 0) {
                                                                            setIsFileSelected(true)
                                                                            setUploadedFileName(sanitizedFiles[0].name)
                                                                        }
                                                                    }}
                                                                    value={supportingDocs}
                                                                    multiple
                                                                >
                                                                    Upload File(s)
                                                                </FileInput>
                                                                <Table
                                                                    columnDefinitions={[
                                                                        {
                                                                            id: "name",
                                                                            header: "File name",
                                                                            cell: file => file.name
                                                                        },
                                                                        {
                                                                            id: "size",
                                                                            header: "File size",
                                                                            cell: file => file.size / 1000 + "KB"
                                                                        },
                                                                        {
                                                                            id: "delete",
                                                                            header: "",
                                                                            cell: (file) => (
                                                                            <Button
                                                                                iconName="close"
                                                                                variant="icon"
                                                                                onClick={() => {
                                                                                    if (processData[PROCESS_KEYS.environment] !== 'Transfer_FAST_RedShift') {
                                                                                        // For non-Transfer_FAST_RedShift: handle both main and supporting files
                                                                                        if (inputFiles.includes(file)) {
                                                                                            setInputFiles((currentFiles) => currentFiles.filter((f) => f !== file));
                                                                                            setIsFileSelected(false);
                                                                                            setUploadedFileName('');
                                                                                        } else {
                                                                                            setSupportingDocs((currentDocs) => currentDocs.filter((doc) => doc !== file));
                                                                                        }
                                                                                    } else {
                                                                                        // Original behavior for Transfer_FAST_RedShift
                                                                                        setSupportingDocs((currentDocs) => currentDocs.filter((doc) => doc !== file));
                                                                                    }
                                                                                }}
                                                                                ariaLabel={`Delete ${file.name}`}
                                                                            />
                                                                        )}
                                                                    ]}
                                                                    items={supportingDocs}
                                                                    empty="No files"
                                                                />
                                                                <br/>
                                                                {  getRequiredDocTypes().length > 0  &&
                                                                    <Alert
                                                                        statusIconAriaLabel="Info"
                                                                        header="Required file types"
                                                                    >
                                                                        Please upload the following types files: 
                                                                        <ul>
                                                                            {getRequiredDocTypes().map((field) => (
                                                                                <li key={field}>{field}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </Alert>
                                                                }
                                                                {
                                                                    (missingMandatoryDocs.length >= 1 &&
                                                                        <Alert
                                                                            statusIconAriaLabel="Error"
                                                                            type="error"
                                                                            header="Required file types are missing"
                                                                        >
                                                                            <SpaceBetween>
                                                                                <Box><h4>Missing file types:</h4>
                                                                                    <ul>
                                                                                        {Array.from(missingMandatoryDocs).map((field) => (
                                                                                            <li key={field}>{field}</li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </Box>
                                                                            </SpaceBetween>
                                                                        </Alert>
                                                                    )
                                                                }
                                                            </SpaceBetween> : <></>
                                                    }
                                                {
                                                    approverNames?.length > 0 && uploadAccessForTheQuarter && (
                                                        <SpaceBetween direction='vertical' size='m'>
	                                                     {renderCertificationSection()}
	                                                 </SpaceBetween>
                                                )}
                                                <RequiredDateColumns
                                                    dashboards={requiredDateDashboardsWithValues}
                                                    loading={requiredDateLoading}
                                                    error={requiredDateError}
                                                    onSelectionChange={setTaskManagerInputs}
                                                />
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    <Button variant="normal" onClick={cancelButtonClick} disabled={submitDisabled}>Cancel</Button>
                                                    {(!shouldShowWbSelection || wbType) && <Button variant="primary" onClick={onSubmitClick} disabled={submitDisabled || (!isFileSelected && wbType !== WB_OPTIONS.NO_POST_WB.value) || (wbType === WB_OPTIONS.NO_POST_WB.value && allowNoPostWBResubmit && !preWbFileId) || ((requireCertificationCheck || dashboardSelfCertify) && approverNames?.length > 0 && !certificationChecked) || requiredDateLoading || !!requiredDateError || !requiredDatesComplete} loading={isPreWbLoading}>Submit</Button>}
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        </Container>
                                    </SpaceBetween>
                                }
                            </SpaceBetween>
                        </div>
                    )
                }
            )
        }

        return tabs
    }

    const errorsContent = (
        <>
            {isFriscoDisabled && <>
                {
                    disabledMessages?.length > 0 ?
                        <SpaceBetween size='xs' direction='vertical'>{disabledMessages.map((message) => <Alert type='error'>{message}</Alert>)}</SpaceBetween> :
                        <Box>This FRISCO is disabled. Please contact the process owner for more details.</Box>
                }
            </>
            }
            {errorMessage ? <Alert statusIconAriaLabel="Error"
                type="error"
                header="Upload restricted">
                {errorMessage} </Alert> : ''}

            </>
    )

    const content = (
        <div>
            {!props.disableAppLayout && (
                <BreadcrumbGroup
                    items={breadcrumbItems}
                    onFollow={onFollowHandler}
                />
            )}
            <div>
                <SpaceBetween size='xs'>
                        
                    {/* Process Comment Section using custom_attributes */}
                    {/* {!isFriscoDisabled && (
                        <ProcessCommentSection
                            processData={processData}
                            processType="FRISCO"
                            onCommentUpdate={handleProcessCommentUpdate}
                            isAteamBiMember={isSupportAdmin}
                            loading={showLoadingIcon}
                            isSubmitting={isCommentSubmitting}
                        />
                    )} */}
                   
                    <Flashbar
                        items={notificationBarItems}
                        i18nStrings={{
                            ariaLabel: "Notifications",
                            notificationBarAriaLabel:
                                "View all notifications",
                            notificationBarText: "Notifications",
                            errorIconAriaLabel: "Error",
                            warningIconAriaLabel: "Warning",
                            successIconAriaLabel: "Success",
                            infoIconAriaLabel: "Info",
                            inProgressIconAriaLabel: "In progress"
                        }}
                        stackItems
                    />
                    <Container
                        header={
                            <Header
                                variant='h2'
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant='normal' onClick={() => { 
                                            if (props.selectedSidebarContent) {
                                                const historyTab = props.selectedSidebarContent.find(
                                                    tab => tab.label.toLowerCase() === 'history'
                                                );
                                                
                                                if (historyTab && historyTab.action) {
                                                    historyTab.action();
                                                } else {
                                                    history.push(`/App/${id}/process/${pid}/history`);
                                                }
                                            } else {
                                                history.push(`/App/${id}/process/${pid}/history`);
                                            }
                                        }}>
                                            View Upload History
                                        </Button>
                                    </SpaceBetween>
                                }
                                description={processData?.[PROCESS_KEYS.description] || ""}
                            > Upload file for process- {getProcessDisplayName()}
                            </Header>
                        }
                    >
                        <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                            {
                                processData?.hasOwnProperty(PROCESS_KEYS.team) && processData?.hasOwnProperty(PROCESS_KEYS.business)
                                    && processData?.hasOwnProperty(PROCESS_KEYS.dataset_name) && processData[PROCESS_KEYS.environment] === 'Transfer_FAST_RedShift' && !hideLoadTable ?
                                    <SpaceBetween size='s' direction='horizontal'>
                                        <Box variant="h4"> Load table : </Box>
                                        {
                                            processData[PROCESS_KEYS.redshift_table_name] ?
                                                <Box>{processData[PROCESS_KEYS.redshift_table_name]}</Box> :
                                                <Box variant="p"> {processData[PROCESS_KEYS.team]}_{processData[PROCESS_KEYS.business]}_{processData[PROCESS_KEYS.dataset_name]}</Box>
                                        }
                                    </SpaceBetween> : <></>
                            }
                            {
                                sessionDetails?.status == 'ACTIVE' && !props.disableAppLayout ? <Box float="right">
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <SegmentedControl
                                            selectedId={uploadSegment}
                                            onChange={({ detail }) =>
                                                setUploadSegment(detail.selectedId)
                                            }
                                            label="Default segmented control"
                                            options={[
                                                { text: "Upload", id: "upload", disabled: !showUploadBtn },
                                                { text: "Inline edit", id: "tanc", disabled: !showUploadBtn || (tancInfo?.status ? false : true) },
                                            ]}
                                        />
                                        {
                                            sessionDetails && !sessionDetails?.s3Uri ?
                                                <Popover
                                                    dismissButton={false}
                                                    position="top"
                                                    size="small"
                                                    triggerType="custom"
                                                    content={
                                                        <Box>Enable Inline editing in FRISCO configuration</Box>
                                                    }
                                                >
                                                    <Icon name="security" />
                                                </Popover> : <></>
                                        }
                                    </SpaceBetween>
                                </Box> : <></>
                            }

                        </Grid>

                    </Container>

                    {showLoadingIcon ? (
                        <Box>
                            <Spinner size="normal"></Spinner>
                            {loadingMessage}
                        </Box>) : ''}
                    {isFriscoDisabled && <>
                        {
                            disabledMessages?.length > 0 ?
                                <SpaceBetween size='xs' direction='vertical'>{disabledMessages.map((message) => <Alert type='error'>{message}</Alert>)}</SpaceBetween> :
                                <Box>This FRISCO is disabled. Please contact the process owner for more details.</Box>
                        }
                    </>
                    }

                    
                    {
                        !isFriscoDisabled && <Tabs
                        activeTabId={activeTabId}
                        variant='container'
                        onChange={(event)=> {
                            if(event.detail.activeTabId ==="first"){
                                prevButtonClick()
                            }
                            else if(event.detail.activeTabId ==="second" && activeTabId === 'third'){
                                setActiveTabId('second')
                            }
                        }}
                        tabs={getUploadTabs()}
                    />
                    }
                </SpaceBetween>
                <Modal
                    visible={showSuccessModal}
                    footer={
                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="primary" onClick={ModalOkClick}>Ok</Button>
                            </SpaceBetween>
                        </Box>
                    }
                    header="File Upload Status"
                >
                    <Box>
                        <SpaceBetween size='m' direction='vertical'>
                            <p>
                                <Icon variant="success" size='medium' name='status-positive'></Icon>
                                &nbsp; &nbsp;
                                Your file has been uploaded for processing. <br></br>
                                File reference : {fileReference}
                            </p>

                        </SpaceBetween>

                    </Box>

                    <br></br>

                </Modal>
            </div>
        </div>
    )


    return (
        <AppLayout
            content={content}
            navigation={<SideNav activeHref={`/App/${id}/process/${pid}/upload`} id={id} pid={pid} process={processData} back={backUrl} />}
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
            contentType="table"
        ></AppLayout>
    );
}
